<template>
  <v-layout
    :class="[
      'workshop-container',
      'workshop-container-zkm',
      !ticketAvailable && !isPartOfCategory && 'not-available',
    ]"
    :style="{
      backgroundColor:
        numberOfTicket !== 0 && numberOfTicket < max_number
          ? backgroundColor
          : activeBackgroundColor,
      border: !isPartOfCategory
        ? 'none'
        : numberOfTicket !== 0 && numberOfTicket < max_number
        ? `1px solid ${cardColor}`
        : `1px solid ${cardColor}80`,
    }"
    justify-space-between
    :column="$vuetify.breakpoint.xsOnly"
  >
    <v-flex xs10>
      <v-layout>
        <v-flex>
          <v-layout column>
            <v-flex class="workshop-title">
              <span
                :style="
                  !ticketAvailable
                    ? !isPartOfCategory
                      ? `color: #979797`
                      : `color: ${cardColor}99`
                    : `color: ${cardColor}`
                "
                >{{ ticket.name }}</span
              >
              <span
                v-if="!ticketAvailable"
                class="soldOut"
                :style="{
                  background: !isPartOfCategory ? `#979797` : `${cardColor}99`,
                }"
                >Rasprodano</span
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout v-if="ticket.description">
        <v-flex>
          <v-layout column>
            <v-flex class="ticket-description">
              <span
                :style="
                  !ticketAvailable
                    ? !isPartOfCategory
                      ? `color: #979797`
                      : `color: ${cardColor}99`
                    : `color: ${cardColor}`
                "
                >{{ ticket.description }}</span
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-layout class="zkm-layout">
      <div class="priceContainer priceContainerZkm">
        <span
          v-if="promoCode && promoCode.orderItems.map(oi => oi.id).includes(ticket.id)"
          :style="{ color: 'red' }"
          class="ticket-price"
        >
          {{ getTicketPrice() }} {{ ticket.currency }}
        </span>
        <span
          v-else
          :style="
            !ticketAvailable
              ? !isPartOfCategory
                ? `color: #979797`
                : `color: ${cardColor}99`
              : `color: ${cardColor}`
          "
          class="ticket-price"
        >
          {{ ticket.price }} {{ ticket.currency }}
        </span>
      </div>
      <v-layout v-if="ticketAvailable" class="add_ticket_icons add_ticket_icons-zkm">
        <v-flex align-self-flex-end class="add_ticket">
          <v-icon
            :id="'reduceAmount-' + ticket.id"
            slot="activator"
            :color="colorZkm"
            icon
            class="quantity-icon"
            :disabled="!numberOfTicket"
            :number-of-ticket="numberOfTicket"
            @click="subOne"
          >
            remove_circle
          </v-icon>
          <div class="ticket-number" translate="no">{{ numberOfTicket }}</div>
          <v-icon
            :id="'increaseAmount-' + ticket.id"
            slot="activator"
            :color="colorZkm"
            icon
            class="quantity-icon"
            :disabled="numberOfTicket == max_number || !canAddMore"
            :number-of-ticket="numberOfTicket"
            @click="addOne"
          >
            add_circle
          </v-icon>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import { round } from 'mathjs'
import { exchangeRate } from '../../../src/utils'
import moment from 'moment'

export default {
  name: 'ticket-card-zkm',
  props: {
    promoCode: {
      default: null,
      type: Object,
    },
    ticket: {
      type: Object,
    },
    canAddMore: {
      type: Boolean,
    },
    color: {
      type: String,
      default: 'primary',
    },
    colorZkm: {
      type: String,
      default: '#333333',
    },
    event: {
      type: Object,
      default: () => {},
    },
    backgroundColor: {
      type: String,
      default: 'primary',
    },
    activeBackgroundColor: {
      type: String,
      default: '#f5f5f5',
    },
    items: {
      type: Array,
      default: () => [],
    },
    isPartOfCategory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      item: this.ticket,
      exchangeRate: exchangeRate,
      max_number: this.ticket.currentlyAvailable,
      ticketAvailable:
        this.ticket.currentlyAvailable > 0 && moment(this.ticket.to).isAfter(new Date()),
      numberOfTicket: this.items.filter(item => item.id === this.ticket.id).length,
      zkmColor: '#333333',
    }
  },
  computed: {
    cardColor() {
      if (this.isPartOfCategory) {
        return this.color
      }

      return this.numberOfTicket !== 0 && this.numberOfTicket < this.max_number
        ? this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
          ? '#333333'
          : this.color
        : '#333333'
    },
  },
  watch: {
    numberOfTicket: function () {
      return this.items.filter(item => item.id === this.ticket.id).length
    },
  },
  beforeUpdate() {
    this.max_number = this.ticket.currentlyAvailable
    this.ticketAvailable =
      this.ticket.currentlyAvailable > 0 && moment(this.ticket.to).isAfter(new Date())
  },
  methods: {
    getTicketPrice() {
      return this.promoCode.discountType === 'AMOUNT'
        ? round(this.ticket.price - this.promoCode.discountAmount, 2)
        : round((this.ticket.price * (100 - this.promoCode.discountPercentage)) / 100, 2)
    },
    addOne() {
      if (this.numberOfTicket < this.max_number || !this.max_number) {
        this.numberOfTicket++
        this.$emit('added', this.ticket)
      }
    },
    subOne() {
      if (this.numberOfTicket >= 1) {
        this.numberOfTicket--
        this.$emit('removed', this.ticket)
      }
    },
  },
}
</script>

<style scoped>
.workshop-title {
  font-family: Raleway, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  line-height: 1.33;
  margin-bottom: 8px;
  margin-right: 24px;
  @media screen and (max-width: 385px) {
    font-size: 15px;
  }
}
.ticket-description {
  font-family: Raleway, serif;
  font-style: normal;
  font-size: 16px;
  color: #333333;
  line-height: 1;
  margin-bottom: 8px;
}

.zkm-layout {
  display: flex;
  @media only screen and (max-width: 620px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.workshop-container {
  padding: 16px 32px 16px 32px;
  border-radius: 8px;
  background-color: #f5f5f5;
  margin: 0;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 12px;
  text-align: left;
  color: #979797;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.workshop-container-zkm {
  margin: 2.4px 0;
  border: solid var(--grey-00, #333);
  border-width: 2px 0;
  border-radius: 0px;
  background-color: transparent !important;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 12px;
  text-align: left;
  color: #979797;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.ticket-number {
  font-family: Source Sans Pro, serif;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  margin-right: 20px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  /*line-height: 84px;*/
  color: #333333;
}

.disabled .workshop-title span,
.disabled span > span {
  color: #333333;
}

.add_ticket_icons {
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-self: flex-end;
  height: 100%;
}

.add_ticket_icons-zkm {
  @media only screen and (max-width: 620px) {
    margin-top: 20px;
    margin-left: 0px;
  }
}
.ticket-price {
  text-align: right;
  color: #333333;
  font-size: 28px;
  font-weight: 900;
  font-family: Source Sans Pro, serif;
  font-style: normal;
  white-space: nowrap;
  line-height: 24px;
  @media screen and (max-width: 385px) {
    font-size: 22px;
  }
}

.ticket-price-before-promo {
  color: #0277bd;
  text-decoration: line-through;
  margin-top: 8px;
}
.add_ticket {
  display: flex;
  align-self: flex-end;
  justify-content: flex-end;
}
.priceContainer {
  display: flex;
  align-content: flex-end;
  margin-bottom: 20px;
}
.priceContainerZkm {
  display: flex;
  align-content: flex-end;
  margin-bottom: 0px;
  margin-right: 40px;
}

.soldOut {
  margin-left: 8px;
  width: 105px;
  height: 22px;
  border-radius: 17.5px;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 120%;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #f5f5f5;
  flex-direction: column;
  align-items: center;
  padding: 4px 12px;
}

.not-available {
  background: transparent !important;
  border: 1px solid #f5f5f5 !important;
  height: fit-content;
}
.layout {
  min-width: unset !important;
}
.quantity-icon {
  user-select: none;
}
</style>
